import { Auth } from 'aws-amplify'
import { APIS } from '@/utils/apiEndpoints'
import { setItemStorage } from '@/utils/storage'
import Constants from '@/utils/constants'
import {
  FETCH_USER,
  AUTH_CHANGE,
  TOGGLE_LOGIN,
  AUTH_LOADING,
} from './authTypes'
import common from '@/utils/common'

export const fetchUser = () => async (dispatch) => {
  try {
    dispatch({ type: AUTH_LOADING, payload: true })
    const user = await Auth.currentUserInfo()
    const { result } = await APIS.getCurrentUser()
    const userInfo = {
      ...result,
      id: user.id,
      cognitoUsername: user?.username,
      isEmailVerified: user.attributes.email_verified,
      newEmail: user.attributes.email,
    }
    setItemStorage(Constants.CURRENT_USER_STORAGE, userInfo)
    dispatch({ type: FETCH_USER, payload: userInfo })
  } catch (error) {
    if (err?.response?.data?.message?.includes('Signature expired')) {
      const signOutUrl = `${process.env.REACT_APP_HOST_PATH}/logout`; // Or whichever URL you configured in Cognito's Allowed Sign-Out URLs
      await Auth.signOut({
        // --- FIX IS HERE ---
        global: true, // Optional: Sign out from all devices
        redirectUri: signOutUrl // CRITICAL: Tells Cognito where to send the user
        // --- END OF FIX ---
      });
      return common.errorToast(
        "We're sorry, but it appears that your login attempt has failed. In order to resolve this issue, we kindly request you to set your system's time zone to update automatically. Once you've made this adjustment, please try logging in again. If you continue to experience any difficulties, please don't hesitate to reach out to our support team for further assistance."
      )
    }
    dispatch({ type: FETCH_USER, payload: {} })
  }
}

export const authChange = () => async (dispatch) => {
  try {
    dispatch({ type: AUTH_LOADING, payload: true })
    await Auth.currentSession()
    dispatch({ type: AUTH_CHANGE, payload: true })
    dispatch({ type: AUTH_LOADING, payload: false })
  } catch (error) {
    dispatch({ type: AUTH_CHANGE, payload: false })
  }
}

export const toggleLogin = () => async (dispatch) => {
  dispatch({ type: TOGGLE_LOGIN, payload: true })
}
